import { render } from "./WarehouseListTableHeader.vue?vue&type=template&id=3be898d3"
import script from "./WarehouseListTableHeader.vue?vue&type=script&lang=js"
export * from "./WarehouseListTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__